import { DoughnutController } from 'chart.js';
import { doughnutThickness } from 'components/shared/graphs/utils';

class CustomDoughnutController extends DoughnutController {

    draw() {
        const width = this.chart.width;
        const height = this.chart.height;
        const ctx = this.chart.ctx;

        // draw center text:
        ctx.restore();
        const fontSize = (height / 80).toFixed(2);
        ctx.font = fontSize + "em Grotesk Condensed";
        ctx.textBaseline = "middle";

        const text = this.options.centertext;
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2 + 5; // for some reason it's not centered perfectly, so +5 helps.

        ctx.fillStyle = "#FFFFFF";
        ctx.fillText(text, textX, textY);
        ctx.save();

        const arcs = this.getMeta().data;

        // arc(x, y, radius, startAngle, endAngle, counterclockwise)

        const drawArc = (arc, isBottom) => {
            const radius     = arc.innerRadius;
            const startAngle = arc.startAngle;
            const endAngle   = arc.endAngle;
            const lineWidth  = doughnutThickness(isBottom);
            const bottomColor = '#142643';  //--color-blue-dark

            ctx.save();
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = isBottom ? bottomColor : arc.options.backgroundColor;

            if (!isBottom) {
                // Draw main arc:
                ctx.save();
                ctx.strokeStyle = ctx.fillStyle = arc.options.backgroundColor;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, radius, startAngle, endAngle);
                ctx.stroke();
                ctx.restore();

                // Draw rounded ball ends that follow it:
                ctx.translate(arc.x, arc.y);
                ctx.strokeStyle = ctx.fillStyle = arc.options.backgroundColor;

                // beginning:
                ctx.beginPath();
                ctx.arc(radius * Math.cos(arc.startAngle), radius * Math.sin(arc.startAngle), lineWidth/2, 0, 2 * Math.PI);
                ctx.closePath();
                ctx.fill();

                // ending:
                ctx.beginPath();
                ctx.arc(radius * Math.cos(arc.endAngle), radius * Math.sin(arc.endAngle), lineWidth/2, 0, 2 * Math.PI);
                ctx.closePath();
                ctx.fill();
            } else {
                // draw black static bottom arc:
                ctx.save();
                ctx.fillStyle = bottomColor;

                ctx.beginPath();
                ctx.arc(arc.x, arc.y, radius, 0, 2 * Math.PI);
                ctx.stroke();

                ctx.restore();
            }
        }

        if (arcs[0]) {
            // draw static black line first:
            drawArc(arcs[0], true);
            drawArc(arcs[0]);
        }
    }
}

CustomDoughnutController.id = 'CustomDoughnut';
CustomDoughnutController.defaults = DoughnutController.defaults;

export default CustomDoughnutController;